export function getQuestionConceptUID(question?: { conceptID?: string; conceptUID?: string; concept_uid?: string }): string | undefined {
  return question?.conceptID || question?.conceptUID || question?.concept_uid;
}
